import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e02ce23"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "bg-white shadow rounded-4 mt-5 mb-4 mb-lg-5 p-xl-4 p-3 pb-4",
  id: "profile-desktop"
}
const _hoisted_2 = { class: "user-container d-flex flex-column justify-content-center align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "fw-bold fs-9 text-center text-break" }
const _hoisted_6 = { class: "fw-bold fs-9 text-center text-break" }
const _hoisted_7 = { class: "text-center fs-7 text-break" }
const _hoisted_8 = { class: "btn-group d-flex justify-content-center align-items-center flex-column mt-3" }
const _hoisted_9 = {
  key: 2,
  class: "groups border-bottom mb-lg-4"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"group mb-5\" data-v-2e02ce23><h4 class=\"fw-bold fs-7 mb-3\" data-v-2e02ce23>参加グループ</h4><ul class=\"\" data-v-2e02ce23><li class=\"d-flex justify-content-between mb-3\" data-v-2e02ce23><div class=\"fs-7\" data-v-2e02ce23>テレワーク研究所 </div><div class=\"count fs-8\" data-v-2e02ce23>25</div></li><li class=\"d-flex justify-content-between mb-3\" data-v-2e02ce23><div class=\"fs-7\" data-v-2e02ce23>テレワーク研究所 </div><div class=\"count fs-8\" data-v-2e02ce23>25</div></li></ul></div><div class=\"group mb-5\" data-v-2e02ce23><h4 class=\"fw-bold fs-7 mb-3\" data-v-2e02ce23>参加グループ</h4><ul class=\"\" data-v-2e02ce23><li class=\"d-flex justify-content-between mb-3\" data-v-2e02ce23><div class=\"fs-7\" data-v-2e02ce23>テレワーク研究所 </div><div class=\"count fs-8\" data-v-2e02ce23>25</div></li><li class=\"d-flex justify-content-between mb-3\" data-v-2e02ce23><div class=\"fs-7\" data-v-2e02ce23>テレワーク研究所 </div><div class=\"count fs-8\" data-v-2e02ce23>25</div></li></ul></div>", 2)
const _hoisted_12 = [
  _hoisted_10
]
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "fw-bold mb-3 fs-7" }
const _hoisted_15 = { class: "d-flex flex-wrap" }

import HashTag from '@/components/hash-tag/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { translate } from '@/languages/i18n'
import { ROOT_STORE } from '@/store/constants'
import { addUserIconParams, userType } from '@/use/usePath'
import Menu from '@/components/layouts/aside/Menu.vue'

export type Tag = {
  community_id: number
  count: number
  id: number
  name: string
}

export type Profile = {
  image_url: string
  family_name: string
  given_name: string
  display_name: string
}

import { ID } from '@/views/user/account/profile/setting/languages/ID'
import { computed, ComputedRef, onMounted, ref } from 'vue-demi'
import communityServices from '@/services/communities.service'
import { useRoute, useRouter } from 'vue-router'
import { CommunityStateTypes } from '@/store/modules/community'
import { useStore } from 'vuex'
import { COMMUNITY_STORE } from '@/store/constants'


export default /*#__PURE__*/_defineComponent({
  props: {
  showTags: {
    type: Boolean,
    default: true,
  },
  showUser: {
    type: Boolean,
    default: true,
  },
  showGroup: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const tags = ref<Array<Tag>>([])

const route = useRoute()
const router = useRouter()
const store = useStore()



const me = computed<ComputedRef<Pick<CommunityStateTypes, 'me'>>>(() => store.getters[COMMUNITY_STORE.GETTERS.GET_ME])

const isMobile = computed<boolean>(() => store?.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

const showTagOnScreen = computed<boolean>(() => {
  if (isMobile.value) return false

  return ['SF10', 'SH10', 'SH20', 'SR40'].includes(route.meta?.screenId as string)
})

onMounted(async () => {
  try {
    if (route.params?.id) {
      const data = await communityServices.getPopularTags(route.params?.id)

      tags.value = data?.data?.data
    }
  } catch (error) {
    console.log(error)
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", {
    class: _normalizeClass(['w-full', _unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}` ? 'mt-lg-5 pt-lg-4' : ''])
  }, [
    (_unref(route).path === `/${_unref(route).path.split('/')[1]}/communities/${_unref(route)?.params?.id}`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(me)?.profile?.image_url ? _unref(addUserIconParams)(_unref(me)?.profile?.image_url, _unref(userType)()) : require('@/assets/images/user-empty.svg'),
              alt: "user",
              class: "mb-2"
            }, null, 8, _hoisted_3),
            (_unref(me))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(UserAliasIcon, {
                    class: "mb-2",
                    userType: _unref(me).employee_user_id ? 1 : 2
                  }, null, 8, ["userType"]),
                  (_unref(me).employee_user_id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("h2", _hoisted_5, _toDisplayString(_unref(me).profile?.display_name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(me).profile?.family_name) + " " + _toDisplayString(_unref(me).profile?.given_name), 1),
                        _createElementVNode("h4", _hoisted_7, _toDisplayString(_unref(me).profile?.display_name), 1)
                      ], 64))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(router).currentRoute.value.params.id}/account/profile/setting`,
              class: "shadow fs-75 border mb-3 rounded-pill text-center text-black text-decoration-none fw-bold"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)(`${_unref(ID)}heading`)), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: `/${_unref(route).path.split('/')[1]}/communities/${_unref(router).currentRoute.value.params.id}/account/portfolio/setting`,
              class: "shadow fs-75 border rounded-pill text-center text-black text-decoration-none fw-bold"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(translate)(`${_unref(ID)}portfolioSetting`)), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isMobile))
      ? (_openBlock(), _createBlock(Menu, { key: 1 }))
      : _createCommentVNode("", true),
    (__props.showGroup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
      : _createCommentVNode("", true),
    (_unref(showTagOnScreen))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("h3", _hoisted_14, _toDisplayString(_unref(translate)('popularTag')), 1),
          _createElementVNode("div", _hoisted_15, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tags.value, (tag) => {
              return (_openBlock(), _createBlock(HashTag, {
                key: tag,
                tag: tag,
                searchable: true,
                class: "me-2 mb-2 m-20"
              }, null, 8, ["tag"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})